/* --- STATE --- */
import { RemediationCheck } from '@ariksa/compliance-policies/api';
import { RiskContextResponse } from '@ariksa/inventory-core';
import { Severity } from '@ariksa/notification';
import {
  AggregatedAlertDetails,
  AggregatedAlertsSummary,
  AlertHistoryResponse,
  AlertResponse,
  EntitySeverityListResponse,
  TopIssuesResponse,
} from '@ariksa/notification/api';
import { DashboardCount } from '@ariksa/reporting';
import { IPagedQueryState } from 'services/utils/PagedQueryState';
import { IQueryState } from 'services/utils/QueryState';
import { Dict } from 'types/utils';

import { SideNavKey } from 'components/Navigation';

export interface FindingsOverviewState {
  resourceCount: IQueryState<DashboardCount>;

  alertHistoryByTrend: IQueryState<AlertHistoryResponse>;
  alertHistoryByStatus: IQueryState<AlertHistoryResponse>;

  topIssuesResolved: IQueryState<TopIssuesResponse>;

  alertByRuleIdRemediationAvailability: IQueryState<RemediationCheck>;
  aggregatedAlertRemediationAvailability: IQueryState<RemediationCheck>;

  topOpenAlerts: Record<string, IQueryState<AlertHistoryResponse>>;
  topAggregatedAlerts: Record<string, IQueryState<AggregatedAlertDetails[]>>;

  aggregateAlertCategories: IQueryState<Dict<Dict<AggregatedAlertsSummary>>>;
  currentCategory: SideNavKey;

  alertFilters: {
    resourceType?: string;
    resourceTypes?: string[];
    alertCategory?: string;
    alertCategories?: string[];
    severity?: Severity;
    severities?: Severity[];
    new_alerts?: boolean;
  };
  findings: IPagedQueryState<AggregatedAlertDetails[]>;
  resourceFailedChecks: IPagedQueryState<Array<AlertResponse>>;
  alertDetailsSeverities: IQueryState<EntitySeverityListResponse>;

  alertsSummaryByCategory: IQueryState<any>;
  remediationCommands: IQueryState<any>;
  alertCountSummary: IQueryState<any>;
  alertsByRuleId: IPagedQueryState<AlertResponse[]>;
  remediationByAlertRuleId: IQueryState<any>;
  prepareRemediation: any;

  findingDescription: IQueryState<any>;
  resourceVPC: IPagedQueryState<any[]>;
  executeRemediation: IQueryState<any>;
  alertWorkflowStatus: IQueryState<Record<string, any>>;
  getAlertLogs: IQueryState<Record<string, any>>;
  connectedEntities: IPagedQueryState<any[]>;
  riskContext: IQueryState<Dict<RiskContextResponse[]>>;
  compliance: IQueryState<Dict<string[]>>;
  findingCompliance: IQueryState<Dict<string[]>>;
}

export type ContainerState = FindingsOverviewState;

export const AlertCategoryClass = {
  DataSecurity: 'Data Security',
  IdentityAuthorization: 'Identity Authorization',
  CloudPosture: 'Cloud Posture',
  Vulnerabilities: 'Vulnerabilities',
};

export type ExceptionFor =
  | 'AggregateFinding'
  | 'Finding'
  | 'Issue'
  | 'Inventory'
  | 'Policy'
  | 'PolicyResource'
  | 'CompliancePolicy';
